import SharedFreePageContent from './SharedFreePageContent';
export default SharedFreePageContent;
